import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Deadlines extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">

          <div className="new_banner">
            <div className="banner_content">
              <h1>AIR-RES 2025</h1>
              <h6>The 2025 International Conference on the</h6>
              <h6>AI Revolution: Research, Ethics, and Society</h6>
              <h6>April 14-16, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
          <h5 className="par_header">DEADLINES - EXTENDED</h5>
          <h6 className="par_header">FOR AUTHORS:</h6>
            <div className="par">
            Since the books/proceedings will be published after the conference, we have some flexibility with the submission deadline. Due to numerous requests, the paper submission deadline has been extended as outlined below. Authors who have already submitted their papers in response to the earlier announcement will receive the decision/status report shortly, if they have not yet done so.
            <br /><br />
            This year's conference will be a hybrid event, combining a live, in-person experience
(face-to-face) with a virtual, online component (Based on a recent survey: 72% of participants will attend in person.)
<br />
<a href="https://www.american-cse.org/air-res2025/presentation_modes" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/air-res2025/presentation_modes </a>

<br /><br />
<b>EXTENDED DEADLINES:</b>
<br /><br />
WE HAVE A REVOLVING DEADLINE: papers will be refereed using the fast-track evaluation system (FTE) – i.e., referees will be assigned to each paper immediately when a paper is submitted.
<br /><br />
            - SUBMISSION OF PAPERS (for peer-review evaluation):<br />
            &emsp; <b>March 2, 2025</b> <br /> 
            &emsp; <a target="_blank" href="https://american-cse.org/air-res-drafts/">https://american-cse.org/air-res-drafts/</a> 
            <br/>            
            <br />

            - NOTIFICATION OF ACCEPTANCE/REJECTION:<br />
            &emsp; <b>REVOLVING DATE</b> <br />
            &emsp; WE HAVE A REVOLVING DEADLINE: papers will be refereed using the fast-track
     evaluation system (FTE) – i.e., referees will be assigned to each paper immediately
     when a paper is submitted. The decision and the evaluation reports will be provided
     to the authors within 10 days from the date of submission.

            <br /><br />

            - REGISTRATIONS:<br />
            &emsp; <b>REVOLVING DATE</b> <br />
            &emsp; <a href="https://american-cse.org/air-res2025/registration" target="_blank" rel="noopener noreferrer">https://american-cse.org/air-res2025/registration</a> <br />
            &emsp; Authors of accepted papers will find the registration deadline in their notification
            of acceptance.
            
            <br /><br />
            - LOCATION AND ROOM RESERVATION: <br />
            &emsp; <b>March 19, 2025</b> <br />
            &emsp; Luxor - an MGM property, Las Vegas, USA <br />
            &emsp; <a href="https://www.american-cse.org/air-res2025/venue" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/air-res2025/venue</a>
            
            
            <br /><br />
            <b>- The 2025 International Conference on the AI Revolution: Research, Ethics, and Society (AIR-RES 2025):</b> <br />
            &emsp; <a href="https://www.american-cse.org/air-res2025/" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/air-res2025/</a> <br />
            &emsp; <b>April 14-16, 2025</b> <br />
            {/* &emsp; + all affiliated Research Tracks: <br />
            &emsp; <a href="https://www.american-cse.org/air-res2025/topics" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/air-res2025/topics</a> <br /> */}
            
            <br />
            - FINAL PAPERS:<br />
            {/* &emsp; <b>May 16, 2025</b> <br /> */}
            &emsp; The conference proceedings will be published after the
                         event. Authors of accepted papers will receive an email
                         with the PUBLICATION link well in advance.

            
{/* <br /><br /><br /> */}
            {/* <i>(Note: We will probably extend the deadlines as needed – however, the sooner a paper is submitted, the sooner notification can be sent.)</i> */}
            <br /><br />
            </div>

            <h6 className="par_header">FOR NON-AUTHORS & NON-SPEAKER ATTENDEES:</h6>
            <div className="par">
            
            - REGISTRATIONS:<br />
            &emsp; <b>March 25, 2025</b> <br />
            &emsp; <a href="https://american-cse.org/air-res2025/registration" target="_blank" rel="noopener noreferrer">https://american-cse.org/air-res2025/registration</a>
            {/* <br /> &emsp; Authors of accepted papers will find the registration deadline in their notification of acceptance. */}
            <br /><br />
            - LOCATION AND ROOM RESERVATION: <br />
            &emsp; <b>March 19, 2025</b> <br />
            &emsp; Luxor - an MGM property, Las Vegas, USA <br />
            &emsp; <a href="https://www.american-cse.org/air-res2025/venue" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/air-res2025/venue</a>

            
            <br /><br />
            <b>- The 2025 International Conference on the AI Revolution: Research, Ethics, and Society (AIR-RES 2025):</b> <br />
            &emsp; <a href="https://www.american-cse.org/air-res2025/" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/air-res2025/</a> <br />
            &emsp; <b>April 14-16, 2025</b> <br />
            {/* &emsp; + all affiliated Research Tracks: <br />
            &emsp; <a href="https://www.american-cse.org/air-res2025/topics" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/air-res2025/topics</a> <br /> */}
            

            </div>

          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Deadlines;